import { Injectable, isDevMode, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Component, ViewChild } from '@angular/core';
import { Profile, currencyCharts, currency } from '../profile/profile';
import { RegurarlyInvestment } from '../profile/regurarlyInvestment';
import { SingleInvestment } from '../profile/singleInvestment';
import { periodeEnum } from '../profile/periodeEnum';
import { DataInvestment } from '../data-investment/dataInvestment';

//import * as $ from 'jquery';
import { FormControl } from '@angular/forms';
import { PdfmakeService } from 'ng-pdf-make/pdfmake/pdfmake.service';
import { CheckColumns } from '../profile/checkColumns';
import { DataInvestmentRegurarly } from '../profile/dataInvestmentRegurarly';
import { reduce } from 'rxjs/operator/reduce';
import { analyzeAndValidateNgModules, CompileShallowModuleMetadata } from '@angular/compiler';
import { color } from 'd3';
import { isNullOrUndefined } from 'util';
import { CurrencyPipe } from '../pipes/currency.pipe';
import { CheckExport } from '../profile/checkExport';
import { CheckChart } from '../profile/checkChart';
import { CanvasPdf } from './canvasPdf';
import { OrientationPdf } from './canvasPdf';
import { environment } from '../../environments/environment';

const colorNameModelation = environment.pdfColorNameModelation;
const colorTextSection = environment.pdfColorTextSection;
const colorTitle =  environment.pdfColorTitle;
const colorTableHeader =  environment.pdfColorTableHeader;
const colorTotalInvestment =  environment.pdfColorTotalInvestment;
const colorTotalInvestmentWithInflation =  environment.pdfColorTotalInvestmentWithInflation;
const colorRent =  environment.pdfColorRent;
const colorRentWithInflation =  environment.pdfColorRentWithInflation;
const colorPayment = environment.pdfColorPayment;
const colorPaymentWithInflation =  environment.pdfColorPaymentWithInflation;
const colorLine =  environment.pdfColorLine;
const colorescriptionAxis =  environment.pdfColorDescriptionAxis;
const colorAxis =  environment.pdfColorAxis;
const colorAxisAmount =   environment.pdfColorAxisAmount;
const logoPdfWidth = environment.logoPdfWidth;
const logoPdfHeight = environment.logoPdfHeight;
const logoPdfAligment = environment.logoPdfAligment;

@Injectable()
export class PdfService {
  profileInvestment: Profile;
  dataInvestment: DataInvestment[];
  checkColumns: CheckColumns;
  checkChart: CheckChart;
  test: boolean;
  graf: string;
  canvasPdf: CanvasPdf;
  public totalInvestmentChart: Array<any> = [];
  public paymentChart: Array<any> = [];
  public RentChart: Array<any> = [];
  public RentInflationChart: Array<any> = [];
  public totalInvestmentWithInflationChart: Array<any> = [];
  public paymentChartInflation: Array<any> = [];
  base64textString: string = '';
  logoBase64: string;
  headerBase64: string;
  enumChargeModeEnum = [
    'Brutto',
    'Netto'
  ];
  constructor(private pdfmake: PdfmakeService) {

  }


  loadLogoToPdf(logoBase64: string){
    this.logoBase64 = logoBase64;
  }
  loalHeaderToPdf(logoBase64Header: string){
    this.headerBase64 = logoBase64Header;
  }

  makePdf(profile: Profile, dataInvestment: DataInvestment[], checkExport: CheckExport) {
    this.profileInvestment = profile;
    this.dataInvestment = dataInvestment;
    this.checkColumns = checkExport.checkColumns;
    this.checkChart = checkExport.checkChart;
    this.canvasPdf = new CanvasPdf(OrientationPdf.landscape);
    this.downloadFilePDF();
  }

  fillDataChartAll() {
    this.paymentChart.splice(0, this.paymentChart.length + 1);
    this.paymentChartInflation.splice(0, this.paymentChartInflation.length + 1);
    this.totalInvestmentWithInflationChart.splice(0, this.totalInvestmentWithInflationChart.length + 1);
    this.totalInvestmentChart.splice(0, this.totalInvestmentChart.length + 1);
    this.RentChart.splice(0, (this.RentChart.length) + 1);
    this.RentInflationChart.splice(0, this.RentInflationChart.length + 1);
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max_rent;
    this.canvasPdf.setPaddingX(this.AmountFormat(Math.round(this.canvasPdf.chart_y_max), false).length);
    this.canvasPdf.caclculateAxisY();
    const val = this.profileInvestment.horizon % 12;
    this.canvasPdf.chart_x_unit = (this.canvasPdf.chart_axis_x_end - this.canvasPdf.chart_axis_x_beginning) / (this.dataInvestment.length - 1 + (12 - val));
    this.canvasPdf.chart_y_unit = (this.canvasPdf.chart_axis_y_end - this.canvasPdf.chart_axis_y_beginning) / this.canvasPdf.chart_y_max;
    let i = 0;
    this.paymentChart.push({ x:  this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.paymentChartInflation.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentChart.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentWithInflationChart.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });

    for (let entry of this.dataInvestment) {
      let step_x = i;
      if (i < this.profileInvestment.horizon) {
        this.totalInvestmentChart.push({ x: ((this.canvasPdf.chart_axis_x_beginning + i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.totalInvestment)) * this.canvasPdf.chart_y_unit) });
        this.totalInvestmentWithInflationChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.totalInvestmentWithInflation)) * this.canvasPdf.chart_y_unit) });
      } else {
        this.RentChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: Math.round(entry.totalInvestment * this.canvasPdf.chart_y_unit) });
        this.RentInflationChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: (Math.round(entry.totalInvestmentWithInflation * this.canvasPdf.chart_y_unit)) });
      }
      if (i === (this.profileInvestment.horizon - 1)) {
          this.RentChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: Math.round(entry.totalInvestment * this.canvasPdf.chart_y_unit) });
          this.RentInflationChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: (Math.round(entry.totalInvestmentWithInflation * this.canvasPdf.chart_y_unit)) });
      }
      this.paymentChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.payment)) * this.canvasPdf.chart_y_unit) });
      this.paymentChartInflation.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.payementInflation)) * this.canvasPdf.chart_y_unit) });
      i++;
    }
  }


  fillDataChartInvestment() {
    this.paymentChart.splice(0, this.paymentChart.length + 1);
    this.paymentChartInflation.splice(0, this.paymentChartInflation.length + 1);
    this.totalInvestmentWithInflationChart.splice(0, this.totalInvestmentWithInflationChart.length + 1);
    this.totalInvestmentChart.splice(0, this.totalInvestmentChart.length + 1);
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max;
    this.canvasPdf.setPaddingX(this.AmountFormat(Math.round(this.canvasPdf.chart_y_max), false).length);
    //this.setPaddingX(this.formatAmountY(this.chart_y_max.toString()).toString.length);
    this.canvasPdf.setPaddingX(this.AmountFormat(Math.round(this.canvasPdf.chart_y_max), false).length);
    this.canvasPdf.caclculateAxisY();
    const val = this.profileInvestment.horizon % 12;
    this.canvasPdf.chart_x_unit = (this.canvasPdf.chart_axis_x_end - this.canvasPdf.chart_axis_x_beginning) / this.profileInvestment.horizon;
    this.canvasPdf.chart_y_unit = (this.canvasPdf.chart_axis_y_end - this.canvasPdf.chart_axis_y_beginning) / this.canvasPdf.chart_y_max;
    this.paymentChart.push({ x: this.canvasPdf.chart_axis_x_beginning , y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.paymentChartInflation.push({ x: this.canvasPdf.chart_axis_x_beginning  , y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentChart.push({ x: this.canvasPdf.chart_axis_x_beginning , y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentWithInflationChart.push({ x: this.canvasPdf.chart_axis_x_beginning , y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    let i = 1;
    for (let entry of this.dataInvestment) {
      if (i <= this.profileInvestment.horizon) {
        this.totalInvestmentChart.push({ x: ((this.canvasPdf.chart_axis_x_beginning + i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.totalInvestment)) * this.canvasPdf.chart_y_unit) });
        this.totalInvestmentWithInflationChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.totalInvestmentWithInflation)) * this.canvasPdf.chart_y_unit) });
        this.paymentChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.payment)) * this.canvasPdf.chart_y_unit) });
        this.paymentChartInflation.push({ x: (this.canvasPdf.chart_axis_x_beginning + (i * this.canvasPdf.chart_x_unit)), y: ((Math.round(entry.payementInflation)) * this.canvasPdf.chart_y_unit) });
      }
      i++;
    }
  }



  fillDataChartRent() {
    this.RentChart.splice(0, (this.RentChart.length) + 1);
    this.RentInflationChart.splice(0, this.RentInflationChart.length + 1);
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max_rent;
    this.canvasPdf.setPaddingX(this.AmountFormat(Math.round(this.canvasPdf.chart_y_max), false).length);
    this.canvasPdf.caclculateAxisY();
    this.canvasPdf.chart_x_unit = (this.canvasPdf.chart_axis_x_end - this.canvasPdf.chart_axis_x_beginning) / (this.profileInvestment.rent.countRent * (12 / this.profileInvestment.rent.periode));
    this.canvasPdf.chart_y_unit = (this.canvasPdf.chart_axis_y_end - this.canvasPdf.chart_axis_y_beginning) / this.canvasPdf.chart_y_max;

    this.paymentChart.push({ x:  this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.paymentChartInflation.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentChart.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    this.totalInvestmentWithInflationChart.push({ x: this.canvasPdf.chart_axis_x_beginning, y: (Math.round(this.dataInvestment[0].payment)) * this.canvasPdf.chart_y_unit });
    let i = 1;
    for (let entry of this.dataInvestment) {
      let step_x = i - this.profileInvestment.horizon;
      if (0 <= step_x) {
        //  if (entry.totalInvestment > 0) {
        this.RentChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: Math.round(entry.totalInvestment * this.canvasPdf.chart_y_unit) });
        this.RentInflationChart.push({ x: (this.canvasPdf.chart_axis_x_beginning + (step_x * this.canvasPdf.chart_x_unit)), y: (Math.round(entry.totalInvestmentWithInflation * this.canvasPdf.chart_y_unit)) });
        /*  }   else {
            this.RentInflationChart.push({ x: ((this.chart_axis_x_beginning + (step_x * this.chart_x_unit))), y: this.chart_axis_y_end });
            this.RentChart.push({ x: (this.chart_axis_x_beginning + (step_x * this.chart_x_unit)), y: this.chart_axis_y_end });
          }*/
      }
      i++;
    }
  }





  downloadFilePDF() {
    console.log('nahravam');

    let dataTableRent = new Array();
    let dataTableInvestment = new Array();

    let orientation_page_pdf = 'landscape';

    dataTableRent.push(this.getHeaderRent());
    dataTableRent = this.createdPdfRentDataTable(dataTableRent);

    dataTableInvestment.push(this.getHeaderDeposit());
    dataTableInvestment = this.createdPdfInvestmentDataTable(dataTableInvestment);

    if (dataTableInvestment[0].length < 9) {
      orientation_page_pdf = 'portrait';
    }

    this.createPdfOptionsPage('portrait');
    let widthHeaderTable = new Array();
    let widthHeaderTableRent = new Array();

    for (let count = 0; dataTableInvestment[0].length > count; count++) {
      widthHeaderTable.push('*');
    }

    for (let count = 0; dataTableRent[0].length > count; count++) {
      widthHeaderTableRent.push('*');
    }


    this.createPdfInfoSingleInvestment();
    this.createPdfInfoRegurarlyInvestment();
    this.createPdfInfoRent();

    if ( this.profileInvestment.rent.on  && this.checkChart.chartAll) {
      // this.canvasPdf.setOrientation(OrientationPdf.portrait);
      this.createChartAll();
      // this.canvasPdf.setOrientation(OrientationPdf.landscape);
    }


    // jednorázové vklady

    this.pdfmake.docDefinition.content.push(
      { text: 'Fáze Vkladů', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle, pageBreak: 'before', pageOrientation: 'landscape' }
    );
    this.pdfmake.docDefinition.content.push({
      style: 'tableExample', fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0],
      table: {
        headerRows: 1,
        widths: widthHeaderTable,
        body:
          dataTableInvestment
      },
      layout: {
        fillColor: function (i, node) {
          return (i % 2 === 0) ? '#EEE' : null;
        },
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#8C8C8C' : '#8C8C8C';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#8C8C8C' : '#8C8C8C';
        },
      }
    });



    if (this.checkChart.chartInvestment) {
      this.createChartInvestment();
    }

    if (this.profileInvestment.rent.on) {

      this.pdfmake.docDefinition.content.push(
        { text: 'Fáze Renta', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle }
      );
      this.pdfmake.docDefinition.content.push({
        style: 'tableExample', fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0],
        //pageBreak: 'before',
        table: {
          headerRows: 1,
          widths: widthHeaderTableRent,
          body:
            dataTableRent
        },
        layout: {
          fillColor: function (i, node) {
            return (i % 2 === 0) ? '#EEE' : null;
          },
          hLineColor: function (i, node) {
            return (i === 0 || i === node.table.body.length) ? '#8C8C8C' : '#8C8C8C';
          },
          vLineColor: function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? '#8C8C8C' : '#8C8C8C';
          },
        }
      });

      if (this.profileInvestment.rent.maxCount === this.profileInvestment.rent.horizon ){
      this.pdfmake.docDefinition.content.push(
        { text: '' , margin: [0, 0, 0, 8], fontSize: 8, bold: true, color: colorTextSection}
      );
      this.pdfmake.docDefinition.content.push(
        { text: 'Dosáhli jste renty, která zajistí Vás, a několik dalších generací. Dále již rentu nezobrazujeme.' , margin: [0, 0, 0, 8], fontSize: 8, bold: true, color: colorTextSection }
      );
      }

      if (this.checkChart.chartRent) {
        this.createChartRent();
      }
    }

    this.pdfmake.docDefinition.footer = [
      { text: this.profileInvestment.createDate.getDate() + "." + (this.profileInvestment.createDate.getMonth() + 1) + "." + this.profileInvestment.createDate.getFullYear(), margin: [40, 40, 40, 40], fontSize: 10, color: '#525659', alignment: 'right' }];

    let name_pdf = 'Investicni-model';

    if (this.profileInvestment.nameModeling) {
      name_pdf = this.profileInvestment.nameModeling;
    };

    this.pdfmake.download(name_pdf);
  }



  createChartRent() {
    this.fillDataChartRent();
    this.canvasPdf.setUnitPeriode(this.profileInvestment.rent.horizon);
    this.canvasPdf.setPeriode(this.profileInvestment.rent.horizon);
    let canvas_data = Array();

    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );
    /* canvas_data.push(
       {
         type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
       }
     );*/
    canvas_data = this.drawChartAxisLineY(canvas_data);
    //canvas_data = this.drawChartAxisLineX(canvas_data, this.profileInvestment.rent.horizon);
    canvas_data = this.drawChartLine(canvas_data, this.RentChart, colorRent, 1);
    canvas_data = this.drawChartLine(canvas_data, this.RentInflationChart, colorRentWithInflation, 1);
    this.drawCircleLegendRent(canvas_data, 5.5);
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Renty', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: colorTitle, pageBreak: 'before', pageOrientation: 'landscape' }
    );

    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );
    this.drawChartLegendRent();
    this.drawAxisX(this.profileInvestment.rent.horizon);
    this.drawAxisY();
  }

  createChartAll() {
    this.fillDataChartAll();
    this.canvasPdf.setUnitPeriode(this.profileInvestment.horizon + this.profileInvestment.rent.horizon);
    this.canvasPdf.setPeriode(this.profileInvestment.horizon + this.profileInvestment.rent.horizon);
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max;
    let canvas_data = Array();

    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );
    /*canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
      }
    );*/
    canvas_data = this.drawChartAxisLineY(canvas_data);
    //canvas_data = this.drawChartAxisLineX(canvas_data, this.dataInvestment.length);
    canvas_data = this.drawChartLine(canvas_data, this.RentChart, colorRent, 1);
    canvas_data = this.drawChartLine(canvas_data, this.RentInflationChart, colorRentWithInflation, 1);
    canvas_data = this.drawChartLine(canvas_data, this.paymentChart, colorPayment, 1);
    canvas_data = this.drawChartLine(canvas_data, this.paymentChartInflation, colorPaymentWithInflation, 1);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentChart, colorTotalInvestment, 1);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentWithInflationChart, colorTotalInvestmentWithInflation, 1);

    this.drawCircleLegendAll(canvas_data, 5.5);
    /*this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů a Renty', fontSize: 16, bold: true, color: '#F4A91C', alignment: 'center', pageBreak: 'before', pageOrientation: 'landscape' }
    );*/
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů a Renty', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: colorTitle, pageBreak: 'before', pageOrientation: 'landscape' }
    );
    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );

    this.drawAxisY();
    this.drawAxisX(this.dataInvestment.length);
    this.drawChartLegendAll();

  }


  createChartInvestment() {
    this.fillDataChartInvestment();
    this.canvasPdf.setUnitPeriode(this.profileInvestment.horizon);
    this.canvasPdf.setPeriode(this.profileInvestment.horizon);
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max;
    let canvas_data = Array();
    /*this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: '#F4A91C' }
    );*/
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );
    /*canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );*/
    canvas_data = this.drawChartAxisLineY(canvas_data);
    //canvas_data = this.drawChartAxisLineX(canvas_data, this.profileInvestment.horizon);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentChart, colorTotalInvestment, 1);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentWithInflationChart, colorTotalInvestmentWithInflation, 1);
    canvas_data = this.drawChartLine(canvas_data, this.paymentChart, colorPayment, 1);
    canvas_data = this.drawChartLine(canvas_data, this.paymentChartInflation, colorPaymentWithInflation, 1);
    this.drawCircleLegendInvestment(canvas_data, 5.5);
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: colorTitle, pageBreak: 'before', pageOrientation: 'landscape' }
    );
    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );

    this.drawChartLegendInvestment();
    this.drawAxisX(this.profileInvestment.horizon);
    this.drawAxisY();

  }

  createChartRentColumn() {

    this.fillDataChartRent();
    let canvas_data = Array();

    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: this.canvasPdf.chart_axis_x_beginning + this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
      }
    );
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
      }
    );
    canvas_data = this.drawChartAxisLineY(canvas_data);
    //canvas_data = this.drawChartAxisLineX(canvas_data, this.profileInvestment.rent.horizon);
    canvas_data = this.drawChartColumnBegin(canvas_data, this.RentChart, '#df2f4a', '#ffffff');
    canvas_data = this.drawChartColumnBegin(canvas_data, this.RentInflationChart, '#9f2440', '#ffffff');
    this.drawCircleLegendRent(canvas_data, 5.5);
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Renty', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: colorTitle }
    );

    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );

    this.drawChartLegendRent();
    this.drawAxisXCenter(this.profileInvestment.rent.horizon);
    this.drawAxisY();

  }



  createChartInvestmentColumn() {
    this.fillDataChartInvestment();
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max;
    let canvas_data = Array();
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: + this.canvasPdf.chart_axis_x_beginning + this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
      }
    );
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.5
      }
    );
    canvas_data = this.drawChartAxisLineY(canvas_data);
    canvas_data = this.drawChartAxisLineX(canvas_data, this.profileInvestment.horizon);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.totalInvestmentChart, '#3E30615', '#ffffff', 0, 1);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.totalInvestmentWithInflationChart, '#ED540B', '#ffffff', 0, 1);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.paymentChart, '#F4A91C', '#ffffff', 0, 1);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.paymentChartInflation, '#FFDD00', '#ffffff', 0, 1);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentChart, 'black', 1);
    this.drawCircleLegendInvestment(canvas_data, 5.5);
    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );
    this.drawChartLegendInvestment();
    this.drawAxisXCenter(this.profileInvestment.horizon);
    this.drawAxisY();
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: colorTitle }
    );
  }

  createChartInvestmentColumn2() {
    this.fillDataChartInvestment();
    this.canvasPdf.chart_y_max = this.profileInvestment.amount_max;
    let canvas_data = Array();
    /*this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: '#F4A91C' }
    );*/
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: this.canvasPdf.chart_axis_y_end, x2: + this.canvasPdf.chart_axis_x_beginning + this.canvasPdf.chart_axis_x_end, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );
    canvas_data.push(
      {
        type: 'line', x1: this.canvasPdf.chart_axis_x_beginning, y1: 0, x2: this.canvasPdf.chart_axis_x_beginning, y2: this.canvasPdf.chart_axis_y_end, lineWidth: 0.8, lineColor: colorAxis
      }
    );
    canvas_data = this.drawChartAxisLineY(canvas_data);
    //canvas_data = this.drawChartAxisLineX(canvas_data, this.profileInvestment.horizon);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.totalInvestmentChart, '#3E30615', '#ffffff', 1, 2);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.totalInvestmentWithInflationChart, '#ED540B', '#ffffff', 1, 2);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.paymentChart, '#F4A91C', '#ffffff', 0, 2);
    canvas_data = this.drawChartColumnEnd(canvas_data, this.paymentChartInflation, '#FFDD00', '#ffffff', 0, 2);
    canvas_data = this.drawChartLine(canvas_data, this.totalInvestmentChart, 'black', 1);
    this.drawCircleLegendInvestment(canvas_data, 5.5);
    this.pdfmake.docDefinition.content.push({
      canvas: canvas_data
    }
    );
    this.drawChartLegendInvestment();
    this.drawAxisXCenter(this.profileInvestment.horizon);
    this.drawAxisY();
    this.pdfmake.docDefinition.content.push(
      { text: 'Vývoj Vkladů', absolutePosition: { x: 375, y: 85 }, fontSize: 16, bold: true, color: '#F4A91C' }
    );
  }

  drawCircleLegendAll(canvas_data: any[], size: number): any {
    // ellipse tottal investment
    const marginLeft = 250;
    canvas_data.push(
      {
        type: 'ellipse',
        //x: 100, y: 5,
        x: 145 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorTotalInvestment,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 200 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorTotalInvestmentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 285 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorPayment,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 375 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorPaymentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });
    canvas_data.push(
      {
        type: 'ellipse',
        x: 100 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorRent,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 20 + marginLeft, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorRentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });
    return canvas_data;
  }


  drawCircleLegendInvestment(canvas_data: any[], size: number): any {
    // ellipse tottal investment
    canvas_data.push(
      {
        type: 'ellipse',
        //x: 100, y: 5,
        x: 390, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorTotalInvestment,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 450, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorTotalInvestmentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 535, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorPayment,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 625, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorPaymentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    return canvas_data;
  }


  drawCircleLegendRent(canvas_data: any[], size: number ): any {
    canvas_data.push(
      {
        type: 'ellipse',
        x: 620, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorRent,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    canvas_data.push(
      {
        type: 'ellipse',
        x: 670, y: this.canvasPdf.chart_axis_y_end + 50,
        color: colorRentWithInflation,
        //fillOpacity: 0.5,
        r1: size, r2: size
      });

    return canvas_data;
  }


  /*getMaxAxisY() {
    let max = 0;
    for (let i = 0; this.profileInvestment.horizon > i; i++) {
      if (!isNullOrUndefined(this.dataInvestment[i].totalInvestment)) {
        if (max < this.dataInvestment[i].totalInvestment) {
          max = this.dataInvestment[i].totalInvestment;
        }
      }
    }
    return max;
  }*/
  drawChartAxisLineY(canvas_data: any[]) {
    // create axys y
    for (let i = 0; (this.canvasPdf.chart_axis_y_value * i) < this.canvasPdf.chart_y_max; i++) {
      canvas_data.push(
        {
          type: 'line',
          lineColor: colorLine,
          x1: this.canvasPdf.chart_axis_x_beginning, y1: (this.canvasPdf.chart_axis_y_end - (i * this.canvasPdf.chart_axis_y_value * this.canvasPdf.chart_y_unit)),
          x2: (this.canvasPdf.chart_axis_x_end), y2: (this.canvasPdf.chart_axis_y_end - (i * this.canvasPdf.chart_axis_y_value * this.canvasPdf.chart_y_unit)),
          lineWidth: 0.5,
          lineCap: 'square'
        },
      );
    }
    return canvas_data;
  }




  drawAxisY() {
    let y_axys = 0;
    for (let i = 0; (this.canvasPdf.chart_axis_y_value * i) < this.canvasPdf.chart_y_max; i++) {

      // tslint:disable-next-line:max-line-length
      const amount = this.AmountFormat(String(Math.round(((this.canvasPdf.chart_axis_y_value * i)))), false);
      const x_axys = this.canvasPdf.chart_axis_x_beginning - 5 + this.formatAmountY(amount) - this.canvasPdf.chart_axis_x_padding_value;
      y_axys =  (this.canvasPdf.chart_axis_y_end - (this.canvasPdf.chart_axis_y_value * i * this.canvasPdf.chart_y_unit) + 95) ;
      this.pdfmake.docDefinition.content.push(
        // tslint:disable-next-line:max-line-length
        { text: amount, absolutePosition: { x: x_axys, y: y_axys }, fontSize: 8, bold: true, color: colorAxisAmount });
    }

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: currencyCharts[this.profileInvestment.currency], absolutePosition: { x: (this.canvasPdf.chart_axis_x_beginning - this.canvasPdf.chart_axis_x_padding_value + this.formatAmountY('Kč')) - 6, y: y_axys - 20 }, fontSize: 8, bold: true, color: colorescriptionAxis, rotate: 90 }
    );
  }

  drawRelativeAxisY() {

    for (let i = 0; (this.canvasPdf.chart_axis_y_value * i) < this.canvasPdf.chart_y_max; i++) {

      // tslint:disable-next-line:max-line-length
      const amount = this.AmountFormat(String(Math.round(((this.canvasPdf.chart_axis_y_value * i)))), false);
      const x_axys = this.canvasPdf.chart_axis_x_beginning - 5 + this.formatAmountY(amount) - this.canvasPdf.chart_axis_x_padding_value;

      this.pdfmake.docDefinition.content.push(
        // tslint:disable-next-line:max-line-length
        { text: amount, relativePosition: { x: x_axys, y: (this.canvasPdf.chart_axis_y_end - (this.canvasPdf.chart_axis_y_value * i * this.canvasPdf.chart_y_unit + 5)) }, fontSize: 8, bold: true, color: '#525659' });
    }


    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: currencyCharts[this.profileInvestment.currency], relativePosition: { x: (this.canvasPdf.chart_axis_x_beginning - this.canvasPdf.chart_axis_x_padding_value + this.formatAmountY('Kč') - 3), y: this.canvasPdf.chart_axis_y_beginning }, fontSize: 8, bold: true, color: colorescriptionAxis, rotate: 90 }
    );
  }

  drawRelativeAxisX(horizon: number) {
    for (let i = 1; horizon >= i; i++) {
      const year = (i % (12 * this.canvasPdf.chart_axis_periode));
      if (year === 0) {
        this.pdfmake.docDefinition.content.push(
          // tslint:disable-next-line:max-line-length
          { text: (i / 12), relativePosition: { x: ((i * this.canvasPdf.chart_x_unit) + this.canvasPdf.chart_axis_x_beginning), y: (this.canvasPdf.chart_axis_y_end + 15) }, fontSize: 8, bold: true, color: '#525659' }
        );
      }
    }
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: ' Roky ', relativePosition: { x: this.canvasPdf.chart_axis_x_end + 25, y: (this.canvasPdf.chart_axis_y_end + 15) }, fontSize: 8, bold: true, color: colorescriptionAxis }
    );
  }




  drawAxisX(horizon: number) {
    for (let i = 1; horizon >= i; i++) {
      const year = (i % (this.canvasPdf.chart_axis_unit_periode * this.canvasPdf.chart_axis_periode ));
      if (year === 0) {
        this.pdfmake.docDefinition.content.push(
          // tslint:disable-next-line:max-line-length
          { text: (i / this.canvasPdf.chart_axis_unit_periode), absolutePosition: { x: ((i * this.canvasPdf.chart_x_unit) + this.canvasPdf.chart_axis_x_beginning + 32), y: (this.canvasPdf.chart_axis_y_end + 110) }, fontSize: 8, bold: true, color: '#525659' }
        );
      }
    }
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: this.canvasPdf.chart_axis_x_label, absolutePosition: { x: this.canvasPdf.chart_axis_x_end + 25, y: (this.canvasPdf.chart_axis_y_end + 125) }, fontSize: 8, bold: true, color: colorescriptionAxis }
    );
  }

  drawAxisXCenter(horizon: number) {
    const year_center = this.canvasPdf.chart_x_unit * 6;
    for (let i = 1; horizon >= i; i++) {
      const year = (i % 12);
      if (year === 0) {
        this.pdfmake.docDefinition.content.push(
          // tslint:disable-next-line:max-line-length
          { text: (i / 12), absolutePosition: { x: ((i * this.canvasPdf.chart_x_unit) + this.canvasPdf.chart_axis_x_beginning - year_center + 35), y: (this.canvasPdf.chart_axis_y_end + 130) }, fontSize: 8, bold: true, color: '#525659' }
        );
      }
    }
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Horizont ( Roky )', absolutePosition: { x: (this.canvasPdf.chart_axis_x_end / 2), y: (this.canvasPdf.chart_axis_y_end + 145) }, fontSize: 8, bold: true, color: '#525659' }
    );
  }


  formatAmountY(amount: String): number {
    let space = 0;
    const max_length = this.AmountFormat(String(Math.round((this.canvasPdf.chart_y_max))), false).length;
    const length_amount = amount.length;
    for (let count = length_amount; max_length > count; count++) {
      space += 3.7;
    }
    return space;
  }



  drawChartLegendInvestment() {
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem', absolutePosition: { x: 440, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorTotalInvestment }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem s inflací', absolutePosition: { x: 500, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorTotalInvestmentWithInflation }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo', absolutePosition: { x: 585, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorPayment }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo s inflací', absolutePosition: { x: 675, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorPaymentWithInflation }
    );
  }


  drawChartLegendAll() {
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem', absolutePosition: { x: 445, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorTotalInvestment }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem s inflací', absolutePosition: { x: 500, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorTotalInvestmentWithInflation }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo', absolutePosition: { x: 585, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorPayment }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo s inflací', absolutePosition: { x: 675, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorPaymentWithInflation }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta', absolutePosition: { x: 400, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorRent }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta s inflací', absolutePosition: { x: 320, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorRentWithInflation }
    );
  }



  drawRelativeChartLegendAll() {
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem', relativePosition: { x: 135, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorTotalInvestment }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Celkem s inflací', relativePosition: { x: 205, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorTotalInvestmentWithInflation }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo', relativePosition: { x: 295, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorPayment }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Historicky vloženo s inflací', relativePosition: { x: 385, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorPaymentWithInflation }
    );
    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta', relativePosition: { x: 100, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorRent }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta s inflací', relativePosition: { x: 5, y: this.canvasPdf.chart_axis_y_end + 35 }, fontSize: 8, bold: true, color: colorRentWithInflation }
    );
  }



  drawChartLegendRent() {

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta', absolutePosition: { x: 670, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorRent }
    );

    this.pdfmake.docDefinition.content.push(
      // tslint:disable-next-line:max-line-length
      { text: 'Renta s inflací', absolutePosition: { x: 720, y: this.canvasPdf.chart_axis_y_end + 145 }, fontSize: 8, bold: true, color: colorRentWithInflation }
    );
  }




  drawChartAxisLineX(canvas_data: any[], horizon: number) {
    // create axys x
    for (let i = 0; i <= horizon; i++) {
      const year = i % (this.canvasPdf.chart_axis_unit_periode * this.canvasPdf.chart_axis_periode);
      if (year === 0) {
        canvas_data.push(
          {
            type: 'line',
            lineColor: colorLine,
            x1: ((i * this.canvasPdf.chart_x_unit) + this.canvasPdf.chart_axis_x_beginning), y1: this.canvasPdf.chart_axis_y_end + 15,
            x2: ((i * this.canvasPdf.chart_x_unit) + this.canvasPdf.chart_axis_x_beginning), y2: 0,
            lineWidth: 0.5,
            lineCap: 'square'
          },
        );
      }
    }
    return canvas_data;
  }



  drawChartLine(canvas_data: any[], chart_data: any[], color: string, x: number): any {
    for (let i = 1; i < chart_data.length; i++) {
      if ( ( this.canvasPdf.chart_axis_y_end - chart_data[i].y)  < 0 ) {
        break;
      }
      canvas_data.push(
        {
          type: 'line',
          lineColor: color,
          color: 'white',
          x1: chart_data[i - 1].x, y1: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y),
          x2: chart_data[i].x, y2: (this.canvasPdf.chart_axis_y_end - chart_data[i].y),
          lineWidth: 3,
          lineCap: 'square'
        },
      );

      if ((i % (this.canvasPdf.chart_axis_unit_periode * this.canvasPdf.chart_axis_periode )) === 0) {
        switch (x) {
          case 1:
            canvas_data.push(
              {
                type: 'ellipse',
                x: chart_data[i].x, y: (this.canvasPdf.chart_axis_y_end - chart_data[i].y),
                color: color,
                //fillOpacity: 0.5,
                r1: 3, r2: 3
              });
            break;
          case 2:
            canvas_data.push(
              {
                type: 'polyline',
                lineWidth: 3,
                closePath: true,
                color: color,
                lineColor: color,
                points: [{ x: (chart_data[i - 1].x + 2), y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y + 2) },
                { x: (chart_data[i - 1].x + 2), y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y - 2) },
                { x: (chart_data[i - 1].x - 2), y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y - 2) },
                { x: (chart_data[i - 1].x - 2), y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y + 2) }]
              });
            break;

          case 3:
            canvas_data.push(
              {
                type: 'polyline',
                lineWidth: 3,
                closePath: true,
                color: color,
                lineColor: color,
                points: [{ x: chart_data[i - 1].x, y: this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y },
                { x: (chart_data[i - 1].x + 3), y: this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y },
                { x: (chart_data[i - 1].x + 3), y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y - 3) }]
              });
            break;
          case 4:
            canvas_data.push(
              {
                type: 'polyline',
                lineWidth: 3,
                closePath: true,
                color: color,
                lineColor: color,
                points: [{ x: chart_data[i - 1].x, y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y + 3) },
                { x: (chart_data[i - 1].x + 3), y: this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y },
                { x: chart_data[i - 1].x, y: (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y - 3) },
                { x: (chart_data[i - 1].x - 3), y: this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y }]
              });
            break;

        }
      }
    }
    return canvas_data;
  }



  drawChartColumnEnd(canvas_data: any[], chart_data: any[], color: string, colorLine: string,
    order: number, count: number): any {
    const width_column_chart = (12 * this.canvasPdf.chart_x_unit) / count;
    const begin_column_chart = this.canvasPdf.chart_x_unit * ((12 / count * order));
    for (let i = 0; i < chart_data.length; i++) {
      if (((i % 12) === 0) || (i === 0)) {
        let y_value = i + 12;
        if ((chart_data.length - 1) === i) {
          break;
        }

        if ((i + 12) > chart_data.length) {
          y_value = chart_data.length - 1;
        }

        canvas_data.push(
          {
            type: 'rect',
            x: chart_data[i].x + begin_column_chart,
            y: (this.canvasPdf.chart_axis_y_end - chart_data[y_value - 1].y),
            w: width_column_chart,
            h: (this.canvasPdf.chart_axis_y_end - (this.canvasPdf.chart_axis_y_end - chart_data[y_value - 1].y)),
            r: 0,
            lineColor: colorLine,
            color: color,
          });
      }
    }
    return canvas_data;
  }


  drawChartColumnBegin(canvas_data: any[], chart_data: any[], color: string, colorLine: string): any {
    for (let i = 1; i < chart_data.length; i++) {
      if (((i % 12) === 0) || (i === 1)) {
        const y_value = i - 1;
        canvas_data.push(
          {
            type: 'rect',
            x: chart_data[i - 1].x,
            y: (this.canvasPdf.chart_axis_y_end - chart_data[y_value].y),
            w: (12 * this.canvasPdf.chart_x_unit),
            h: (this.canvasPdf.chart_axis_y_end - (this.canvasPdf.chart_axis_y_end - chart_data[i - 1].y)),
            r: 0,
            lineColor: colorLine,
            color: color,
          });
      }
    }
    return canvas_data;
  }





  createPdfInfoRegurarlyInvestment() {
    let countRegurarlyInvestment = 0;
    for (let regurarlyInvestment of this.profileInvestment.regurarlyInvestments) {
      countRegurarlyInvestment++;
      this.createdInvestmentPdfRegurarlyInfo(regurarlyInvestment, countRegurarlyInvestment);
    }
  }
  createPdfInfoSingleInvestment() {
    let countSingleInvestment = 0;
    for (let singleInvestment of this.profileInvestment.singleInvestments) {
      countSingleInvestment++;
      this.createdPdfInvestmentSingleInfo(singleInvestment, countSingleInvestment);
    }
  }


  /*
  *
  */
  createdPdfInvestmentSingleInfo(investmentSingle: SingleInvestment, countInvestment: number) {
    this.pdfmake.docDefinition.content.push(
      { text: countInvestment + '. Jednorázový vklad', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle }
    );
    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Jednorázý brutto vklad:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: this.AmountFormat(String(investmentSingle.singleBruttoInvestment), true), margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      }
    );
    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Vklad proveden:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: String(investmentSingle.number_charge + '.' + ' Měsíc'), margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      }
    );
    this.pdfmake.docDefinition.content.push({
      columns: [
        // tslint:disable-next-line:max-line-length
        { text: 'Základna pro výpočet poplatku:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
        { text: String(this.enumChargeModeEnum[investmentSingle.chargeModeSingle - 1]), margin: [0, 0, 0, 8], fontSize: 10 }
      ]
    }
    );
    this.pdfmake.docDefinition.content.push({
      columns: [
        // tslint:disable-next-line:max-line-length
        { text: 'Sazba vstupního poplatku:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
        { text: String(investmentSingle.inputChargeSingleInvestment) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
      ]
    }
    );

    this.pdfmake.docDefinition.content.push({
      columns: [
        // tslint:disable-next-line:max-line-length
        { text: 'Výše poplatku: ', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
        { text: this.AmountFormat(String(Math.round(investmentSingle.charge)), true), margin: [0, 0, 0, 8], fontSize: 10 }
      ]
    }
    );
    this.pdfmake.docDefinition.content.push({
      columns: [
        // tslint:disable-next-line:max-line-length
        { text: 'Netto jednorázových vkladů:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
        { text: this.AmountFormat(String(Math.round(investmentSingle.nettoSingleInvestment)), true), margin: [0, 0, 0, 8], fontSize: 10 }
      ]
    },
      { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: '#3f51b5' }
    );
  }


  /*
  *
  */
  createdInvestmentPdfRegurarlyInfo(regurarlyInvestment: RegurarlyInvestment, countRegurarlyInvestment: number) {
    this.pdfmake.docDefinition.content.push(
      { text: countRegurarlyInvestment + '. Pravidelný vklad', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle }
    );


    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Pravidelný brutto vklad:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: this.AmountFormat(String(regurarlyInvestment.regurarlyBruttoInvestment), true), margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      },
    );


    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Perioda pravidelných vkladů:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: String(periodeEnum[regurarlyInvestment.periode]), margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      }
    );

    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Trvání vkladu:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: String(regurarlyInvestment.horizon) + ' Měsíců', margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      }
    );

    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: 'Vklad proveden:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
          { text: String(regurarlyInvestment.horizonStart) + '. Měsíc', margin: [0, 0, 0, 8], fontSize: 10 }
        ]
      }
    );


    if (!isNaN(regurarlyInvestment.valorizationPercent) || (regurarlyInvestment.valorizationPercent > 0)) {
      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Valorizace vkladů:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: regurarlyInvestment.valorizationPercent + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );
    }

    if (regurarlyInvestment.chargeModeRegurarly == 1) {
      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Základna pro výpočet poplatku:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: 'Brutto', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );
    } else {
      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Základna pro výpočet poplatku:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: 'Netto', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );
    }



    this.showInfoCharge(regurarlyInvestment);

    // pravidelné  vklady
    this.pdfmake.docDefinition.content.push(
      {
        columns: [
          // tslint:disable-next-line:max-line-length
          { text: ' ', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection }
        ]
      }
    );


  }


  createTableChargeSale(regurarlyInvestment: RegurarlyInvestment): Array<Object> {
    let TableChargeSale = new Array();
    TableChargeSale.push(this.createHeaderChargeSale());
    for (let interval of regurarlyInvestment.sale.interval) {
      TableChargeSale.push([this.AmountFormat(String(Math.round(interval.begin)), true), this.AmountFormat(String(Math.round(interval.end)), true), interval.percent + ' %']);
    }
    return TableChargeSale;
  }



  showInfoCharge(regurarlyInvestment: RegurarlyInvestment) {
    switch (regurarlyInvestment.typeChargeRegurarly) {
      case 1:

        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Způsob účtování poplatků:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Průběžný', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );

        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Typ poplatků:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Konstantní', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
          { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: '#3f51b5' },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Sazba vstupního poplatku pravidelných vkladů:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: String(regurarlyInvestment.chargeFromInvestment) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Poplatek z každého vkladu:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: this.AmountFormat(String(Math.round(regurarlyInvestment.charge)), true), margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Celkový poplatek za dobu trvání pravidelného vkladu:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: this.AmountFormat(String(Math.round(regurarlyInvestment.sumChargeRegurarly)), true), margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        return;
      // Průběžný poplatek se slevou za historicky dosažený objem
      case 2:
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Způsob účtování poplatků:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Průběžný', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Typ poplatků:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Proměnný dle objemu', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        const widthHeaderTable = new Array();
        let dataTableSale = new Array();
        dataTableSale.push(this.createHeaderChargeSale());
        dataTableSale = this.createTableChargeSale(regurarlyInvestment);

        for (let count = 0; dataTableSale.length > count; count++) {
          widthHeaderTable.push('*');
        }
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Celkový poplatek za dobu trvání pravidelného vkladu:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: this.AmountFormat(String(Math.round(regurarlyInvestment.sumChargeRegurarly)), true), margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );

        this.pdfmake.docDefinition.content.push(
          { text: 'Intervaly slev za objem', margin: [0, 10, 0, 8], fontSize: 12, bold: true, color: colorTextSection }
        );
        this.pdfmake.docDefinition.content.push({
          style: 'table interval sale', fontSize: 8, alignment: 'center', margin: [0, 0, 0, 0],
          table: {
            headerRows: 1,
            widths: widthHeaderTable,
            body:
              dataTableSale
          },
          layout: {
            fillColor: function (i, node) {
              return (i % 2 === 0) ? '#EEE' : null;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#8C8C8C' : '#8C8C8C';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#8C8C8C' : '#8C8C8C';
            },
          }
        });
        return;
      // 'Placený zvlášť s prvním vkladem'
      case 3:
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Způsob účtování poplatků', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Předplacený', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Typ poplatků', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Splacený z prvních vkladů', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Celkový poplatek vkladu:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: this.AmountFormat(String(Math.round(regurarlyInvestment.sumChargeRegurarly)), true), margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        return;
      case 4:
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Způsob účtování poplatků', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Předplacený', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Typ poplatku', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: 'Splacený z prvních vkladů', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
          { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: colorTextSection },
        );
        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Sazba vstupního poplatku pravidelných vkladů:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: String(regurarlyInvestment.chargeFromInvestment) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );

        this.pdfmake.docDefinition.content.push(
          {
            columns: [
              // tslint:disable-next-line:max-line-length
              { text: 'Na poplatek z plateb jde:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
              { text: String(regurarlyInvestment.sale.percentCharge) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
            ]
          },
        );
        return;
    }
  }


  getHeaderDeposit(): Array<Object> {
    let dataHeaderTable = Array();
    if (this.checkColumns.checkNumberCharge) {
      dataHeaderTable.push({ text: this.checkColumns.getTitleHorizon(), style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkPayment) {
      dataHeaderTable.push({ text: 'Historicky vloženo', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkPayementInflation) {
      dataHeaderTable.push({ text: 'Vklad s inflací', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkchargeHorizont) {
      dataHeaderTable.push({ text: 'Zaplacené poplatky', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkChargeCumulatively) {
      dataHeaderTable.push({ text: 'Poplatky kumulativně', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkSingleInvestment && (this.profileInvestment.singleInvestments.length > 0)) {
      dataHeaderTable.push({ text: 'Jednorázově', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkSingleInvestmentWithInflation && (this.profileInvestment.singleInvestments.length > 0)) {
      dataHeaderTable.push({ text: 'Jednorázově s inflací', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkRaegurarlyInvestment && (this.profileInvestment.regurarlyInvestments.length > 0)) {
      dataHeaderTable.push({ text: 'Pravidelně', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkRegurarlyInvestmentWithInflation && (this.profileInvestment.regurarlyInvestments.length > 0)) {
      dataHeaderTable.push({ text: 'Pravidelně s inflací', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkTotalInvestment) {
      dataHeaderTable.push({ text: 'Celkem', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    if (this.checkColumns.checkTotalInvestmentWithInflation) {
      dataHeaderTable.push({ text: 'Celkem s inflací', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    }
    return dataHeaderTable;

  }



  getHeaderRent(): Array<Object> {
    let dataHeaderTableRent = new Array();
    dataHeaderTableRent.push({ text: this.checkColumns.getTitleHorizon(), style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Vybráno nominálně', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Vybráno reálně', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Průběh celkem', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Průběh celkem s inflací', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    return dataHeaderTableRent;

  }
  createHeaderChargeSale(): Array<Object> {
    let dataHeaderTableRent = new Array();
    dataHeaderTableRent.push({ text: 'Od', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Do', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    dataHeaderTableRent.push({ text: 'Platba', style: 'tableHeader', fillColor: colorTableHeader, color: '#ffffff' });
    return dataHeaderTableRent;

  }

  createdPdfInvestmentDataTable(dataTable: Array<Object>): Array<Object> {
    let horizon = 0;
    let horizonInvestment = 1;
    for (let data of this.dataInvestment) {
      if (horizon <= (this.profileInvestment.horizon)) {
        // tslint:disable-next-line:max-line-length
        if ((this.checkColumns.detailHorizon === true) || ((this.checkColumns.detailHorizon === false) && (this.checkDetail(horizon)))) {
          // tslint:disable-next-line:max-line-length
          const dataRow = new Array();
          if (this.checkColumns.checkNumberCharge) { dataRow.push(String(horizonInvestment)); }
          if (this.checkColumns.checkPayment) { dataRow.push(String(this.AmountFormat(String(Math.round(data.payment)), true))); }
          if (this.checkColumns.checkPayementInflation) { dataRow.push(String(this.AmountFormat(String(Math.round(data.payementInflation)), true))); }
          // tslint:disable-next-line:max-line-length
          if (this.checkColumns.checkchargeHorizont) { dataRow.push(String(this.AmountFormat(String(Math.round(this.showYearCharge(horizon))), true))); }
          if (this.checkColumns.checkChargeCumulatively) { dataRow.push(String(this.AmountFormat(String(Math.round(data.chargeCumulatively)), true))); }
          if (this.checkColumns.checkSingleInvestment && (this.profileInvestment.singleInvestments.length > 0)) {
            dataRow.push(String(this.AmountFormat(String(Math.round(data.singleInvestment)), true)));
          }
          // tslint:disable-next-line:max-line-length
          if (this.checkColumns.checkSingleInvestmentWithInflation && (this.profileInvestment.singleInvestments.length > 0)) { dataRow.push(String(this.AmountFormat(String(Math.round(data.singleInvestmentWithInflation)), true))); }
          if (this.checkColumns.checkRaegurarlyInvestment && (this.profileInvestment.regurarlyInvestments.length > 0)) { dataRow.push(String(this.AmountFormat(String(Math.round(data.raegurarlyInvestment)), true))); }
          // tslint:disable-next-line:max-line-length
          if (this.checkColumns.checkRegurarlyInvestmentWithInflation && (this.profileInvestment.regurarlyInvestments.length > 0)) { dataRow.push(String(this.AmountFormat(String(Math.round(data.regurarlyInvestmentWithInflation)), true))); }
          if (this.checkColumns.checkTotalInvestment) { dataRow.push(String(this.AmountFormat(String(Math.round(data.totalInvestment)), true))); }
          // tslint:disable-next-line:max-line-length
          if (this.checkColumns.checkTotalInvestmentWithInflation) { dataRow.push(String(this.AmountFormat(String(Math.round(data.totalInvestmentWithInflation)), true))); }
          dataTable.push(dataRow);
          horizonInvestment++;
        }
      }
      horizon++;
    }
    return dataTable;
  }

  checkDetailRenta(index: number): boolean {
    if (index === ((this.dataInvestment.length - 1) - this.profileInvestment.horizon)) {
      return true;
    }
    if (index === 0) {
      return true;
    }
    if (((index) % 12) === 0) {
      return true;
    }
    return false;
  }


  createdPdfRentDataTable(dataTableRent: Array<Object>): Array<Object> {
    let horizon = 0;
    let horizonRent = 1;
    for (let data of this.dataInvestment) {
      if (horizon >= (this.profileInvestment.horizon)) {
        if ((this.checkColumns.detailHorizon === true) || ((this.checkColumns.detailHorizon === false) && (this.checkDetail(horizon)))) {
          const dataRow = new Array();
          dataRow.push(String(horizonRent));
          dataRow.push(String(this.AmountFormat(String(Math.round(this.showYearCashout(horizon))), true)));
          dataRow.push(String(this.AmountFormat(String(Math.round(this.showYearCashoutReal(horizon))), true)));
          dataRow.push(String(this.AmountFormat(String(Math.round(data.totalInvestment)), true)));
          ///dataRow.push(String(this.AmountFormat(String(data.totalInvestmentWithInflation))));
          dataRow.push(String(this.AmountFormat(String(Math.round(data.totalInvestmentWithInflation)), true)));
          horizonRent++;

          dataTableRent.push(dataRow);
        }
      }
      horizon++;
    }
    return dataTableRent;
  }

  createPdfInfoRent() {
    if (this.profileInvestment.rent.on) {
      this.pdfmake.docDefinition.content.push(
        { text: ' Parametry Renty', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle }
      );


      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Renta:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: this.AmountFormat(String(Math.round(this.profileInvestment.rent.minRent)), true), margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );
      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Perioda čerpání:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: String(periodeEnum[this.profileInvestment.rent.periode]), margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );

      this.pdfmake.docDefinition.content.push(
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Zhodnocení fáze renty:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: String(this.profileInvestment.rent.evaluationBrutto + ' %'), margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
      );

      switch (this.profileInvestment.rent.typeCalculation) {
        case 1:

          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Typ výpočtu renty:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: 'Renta z úspor v nominální výši na dopočtenou dobu', margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
          );
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Rentu je možné čerpat v plné výši:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: this.profileInvestment.rent.countRent + ' krát, tedy ' + this.profileInvestment.generateLabelTimeNoSpace(this.profileInvestment.rent.countRent), margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
            { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: colorTextSection },
          );
          return;
        case 2:

          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Typ výpočtu renty:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: 'Renta z úspor v reálné výši na dopočtenou dobu', margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
          );
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Rentu je možné čerpat v plné výši:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: this.profileInvestment.rent.countRent + ' krát, tedy ' + this.profileInvestment.generateLabelTimeNoSpace(this.profileInvestment.rent.countRent), margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
            { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: colorTextSection },
          );
          return;
        case 3:
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Typ výpočtu renty:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: 'Renta z úspor na zadanou dobu v dopočtené nominální výši', margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
          );
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Rentu je možné čerpat v plné výši:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: this.profileInvestment.rent.countRent + ' krát, tedy ' + this.profileInvestment.generateLabelTimeNoSpace(this.profileInvestment.rent.countRent), margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
            { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: '#3f51b5' },
          );
          return;
        case 4:
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Typ výpočtu renty:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: 'Renta z úspor na zadanou dobu v dopočtené reálné výši', margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
          );
          this.pdfmake.docDefinition.content.push(
            {
              columns: [
                // tslint:disable-next-line:max-line-length
                { text: 'Rentu je možné čerpat v plné výši:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
                { text: this.profileInvestment.rent.countRent + ' krát, tedy ' + this.profileInvestment.generateLabelTimeNoSpace(this.profileInvestment.rent.countRent), margin: [0, 0, 0, 8], fontSize: 10 }
              ]
            },
            { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: '#3f51b5' },
          );
      }
    }
  }

  createPdfOptionsPage(orientation_page_pdf) {
    let _nameModeling = 'Investiční model';
    console.log(this.headerBase64);
    if (this.profileInvestment.nameModeling !== undefined) {
      _nameModeling = this.profileInvestment.nameModeling;
    }
    let a = {
      pageOrientation: 'portrait',
      pageMargins: [40, 100, 40, 80],
      background: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
        ///image: 'data:image/png;base64,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',
          image: this.headerBase64,
          width: 850,
          height: 65
        },
        { text: _nameModeling, margin: [40, -40, 0, 30], fontSize: 20, color:  colorNameModelation , alignment: 'left' }
      ],
      header: [
        // tslint:disable-next-line:max-line-length
        {
          image: this.logoBase64,
          //image: 'data:image/png;base64,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',
          height: Number(logoPdfHeight),
          width: Number(logoPdfWidth),
          alignment: logoPdfAligment,
          margin: [15, 15, 10, 10]
        }
      ],
      content: [
        /*{dataRowSingle
        },*/
        { text: 'Obecné parametry modelace', margin: [0, 0, 0, 8], fontSize: 14, bold: true, color: colorTitle },
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Horizont:', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection, lineHeight: 0.2 },
            { text: String(this.profileInvestment.horizon) + ' Měsíců', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Předpokládané brutto zhodnocení (% p.a.): ', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: String(this.profileInvestment.assumptionEvaluation) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Předpokládaná inflace (% p.a.):', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: String(this.profileInvestment.assumptionInflation) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
        {
          columns: [
            // tslint:disable-next-line:max-line-length
            { text: 'Zhodnocení se započtením inflace (% p.a.):', margin: [0, 0, 0, 8], fontSize: 10, color: colorTextSection },
            { text: String(this.precisionRound(this.profileInvestment.evaluationWithInflation, 2)) + ' %', margin: [0, 0, 0, 8], fontSize: 10 }
          ]
        },
        { text: '', margin: [0, 20, 0, 8], fontSize: 10, bold: true, color: colorTextSection },
      ]
    };

    //console.log('data:image/png;base64,' + this.graf);

    this.pdfmake.docDefinition = a;

  }

  AmountFormat(value: any, currency: boolean): String {
    Math.round(value);
    let _substrResult = '';
    let _substr = '';
    let _count: number;
    let _amount;
    if (value === undefined) {
      return '0';
    }
    const typ: string = typeof value;
    if (value instanceof String) {
      _amount = value;
    }
    else {
      _amount = value.toString();
    }
    let _countFloat = String((_amount.length) / 3);
    let a = _countFloat.split('.');
    let re = '/\.[0-9]+/gi';
    _count = Number(a[0]);
    const _countMod = (_amount.length) % 3;
    if (_amount.length > 3) {
      let _start_pos = -3;
      for (let i = 0; i < (_count); i++) {
        _substr = _amount.substr(_start_pos, 3);
        _start_pos -= 3;
        _substrResult = _substr + ' ' + _substrResult;
      }
      if (_countMod > 0) {
        _substr = _amount.substr(0, _countMod);
        _substrResult = _substr + ' ' + _substrResult;
      }
    }
    else {
      _substrResult = _amount;
    }
    if (currency) {
      return _substrResult + ' ' + currencyCharts[this.profileInvestment.currency];
    } else {
      return _substrResult;
    }
  }

  precisionRound(_number: number, precision: number): number {
    let factor = Math.pow(10, precision);
    return Math.round(_number * factor) / factor;
  }



  showYearCharge(indexYear: number): number {
    let chargeSum = 0;
    if (this.checkColumns.detailHorizon) {
      return this.dataInvestment[indexYear].charge;
    } else {
      for (let u = 0; 12 > u; u++) {
        if (this.dataInvestment[indexYear - u].charge !== undefined) {
          chargeSum += this.dataInvestment[indexYear - u].charge;
        }
      }
    }
    return chargeSum;
  }

  showYearCashout(indexYear: number): number {
    let cashoutSum = 0;
    let max_count = 12;
    if (this.checkColumns.detailHorizon || indexYear === 0) {
      return this.dataInvestment[indexYear].cashout;
    } else {
       const delay = (indexYear -  this.profileInvestment.horizon + 1) % 12;
      if (delay > 0) {
        max_count =   delay;
      }
      for (let u = 0; max_count > u; u++) {
        cashoutSum += this.dataInvestment[indexYear - u].cashout;
      }
    }
    return cashoutSum;
  }
  showYearCashoutReal(indexYear: number): number {
    let cashoutSum = 0;
    let max_count = 12;
    let real_cashout = 0;
    if (this.checkColumns.detailHorizon || indexYear === 0) {
      return this.dataInvestment[indexYear].cashoutReal;
    } else {
      const delay = (indexYear -  this.profileInvestment.horizon + 1) % 12;
      if (delay > 0) {
        max_count =   delay;
      }
      for (let u = 0; max_count > u; u++) {
        if (isNaN(this.dataInvestment[indexYear - u].cashoutReal)) {
          real_cashout = 0;
        } else {
          real_cashout = this.dataInvestment[indexYear - u].cashoutReal;
        }

        cashoutSum += real_cashout;
      }
    }
    return cashoutSum;
  }



  checkDetail(index: number): boolean {
    if (index === 0) {
      return false;
    }
    if (((index + 1) % 12) === 0) {
      return true;
    }
    if ((index + 1) === this.dataInvestment.length) {
      console.log(index);
      return true;
    }

    return false;
  }

}
